import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';
import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderDisclaimer = (props: Props) => {
  const { disclaimer, rounded = true } = props;

  const { match } = useResponsive();
  const { right: safeAreaRightInset, left: safeAreaLeftInset } = useSafeAreaInsets();

  // ─── Styles ──────────────────────────────────────────────────────────

  const innerContainerXSDynamicStyles = useStyle(() => {
    return {
      paddingRight: Math.max(safeAreaRightInset, theme.spacing['4']),
      paddingLeft: Math.max(safeAreaLeftInset, theme.spacing['4']),
    };
  }, [safeAreaRightInset, safeAreaLeftInset]);

  const containerStyles = [styles.container, rounded ? styles.roundedContainer : undefined];
  const innerContainerStyles = [
    styles.innerContainer,
    match([innerContainerXSDynamicStyles, undefined]),
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      <View style={innerContainerStyles}>
        <BodyText sizeMatch={['14']} style={match([undefined, styles.textSM])}>
          {disclaimer}
        </BodyText>
      </View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.CREAM,
    overflow: 'hidden',
  },
  roundedContainer: {
    borderBottomStartRadius: theme.radius.medium,
    borderBottomEndRadius: theme.radius.medium,
  },
  textSM: {
    textAlign: 'center',
  },
  innerContainer: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
    padding: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  disclaimer: string;
  rounded?: boolean;
};
